<template>
  <div class="app-personal-data-wrapper">
    <slot v-if="getView === 'personalDataChangeSuccess'" name="textSuccess">
      <div class="label col-12 col-md-12" name="textSuccess">Deine persönlichen Daten wurden erfolgreich geändert.</div>
    </slot>
    <slot v-if="getView === 'SendVerificationMail' || getShowSendVerificationMail_ === true" name="textSuccessEmail">
      <div class="label col-12 col-md-12" name="textSuccessEmail">Du erhältst an die eingegebene E-Mail-Adresse eine E-Mail mit einem Bestätigungslink.</div>
    </slot>
    <ViewPersonalData
      v-if="getView === 'viewPersonalData' || getView === 'personalDataChangeSuccess' || getView === 'SendVerificationMail'"
      :current-customer="currentCustomer"
    >
      <template v-for="slot in possibleChildSlotsFor('View')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ViewPersonalData>
    <ChangePersonalData
      v-if="getView === 'changePersonalData'"
      :current-customer="currentCustomer"
      @refresh="refreshQuery"
      ref="change"
    >
      <template v-for="slot in possibleChildSlotsFor('Change')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ChangePersonalData>
  </div>
</template>

<script>
import ViewPersonalData from '@/components/process/generic/PersonalData/fyve/View.vue'
import ChangePersonalData from '@/components/process/generic/PersonalData/fyve/Change.vue'
import { mapGetters, mapMutations } from 'vuex'
import transaction from '@/mixins/transaction'
import slotProxy from '../../../../../mixins/slotProxy'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'

export default {
  name: 'PersonalDataWrapper',
  mixins: [
    transaction('personalData'),
    slotProxy()
  ],
  data () {
    return {
      currentCustomer: {
        salutation: '',
        firstName: '',
        lastName: '',
        birthDate: '',
        address: {
          city: '',
          houseNumber: '',
          street: '',
          supplement: '',
          zip: ''
        },
        email: ''
      }
    }
  },
  computed: {
    ...mapGetters('personalData', [
      'getView',
      'getEditView',
      'getShowSendVerificationMail'
    ]),
    getShowSendVerificationMail_: function () {
      if (this.getShowSendVerificationMail) {
        this.deactivateShowSendVerificationText()
        return true
      }
      return this.getShowSendVerificationMail
    }
  },
  created: function () {
    this.goToViewState()
  },
  methods: {
    ...mapMutations('personalData', [
      'changeToEditView',
      'changeToView',
      'deactivateShowSendVerificationText'
    ]),
    goToViewState () {
      this.changeToView()
    },
    refreshQuery () {
      this.$apollo.queries.currentCustomer.refetch()
    }
  },
  components: {
    ChangePersonalData,
    ViewPersonalData
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(
        gql`query personalData{
          currentCustomer {
            salutation,
            firstName,
            birthDate,
            lastName,
            address {
              city,
              houseNumber,
              street,
              supplement,
              zip
            },
            email
          }
        }`, this, 'currentCustomer'
      )
    }
  }
}
</script>
